import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

const API_URL = process.env.REACT_APP_BASE_URL + "/api/v1/user";

export default function addUser(data) {
    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${authToken}`,
        },
    };

    return (
        axios.post(API_URL, qs.stringify(data), config)
        .then(res => {            
            // console.log("Response: ", res);
            return res;  
        })
        .catch(err => {
            // console.log("Error: ", err);
            return err;
        })
    );
}
